import React, { forwardRef } from 'react';
import { View, ScrollView } from 'react-native';
import { LuxSizeKeys } from "../../../typings";
import styled from "../../../theming/util/styled";
import Iffy from "../../util/Iffy/Iffy";
import util from "../../util";
// TYPE CITY
export var DNABoxAppearanceEnum;
(function (DNABoxAppearanceEnum) {
    DNABoxAppearanceEnum["row"] = "row";
    DNABoxAppearanceEnum["col"] = "col";
    DNABoxAppearanceEnum["colReverse"] = "col-reverse";
    DNABoxAppearanceEnum["rowReverse"] = "row-reverse";
})(DNABoxAppearanceEnum || (DNABoxAppearanceEnum = {}));
export const DNABoxAppearanceKeys = Object.keys(DNABoxAppearanceEnum);
// Not the most fool-proof way ...
export var DNABoxSpacingEnum;
(function (DNABoxSpacingEnum) {
    DNABoxSpacingEnum["between"] = "between";
    DNABoxSpacingEnum["around"] = "around";
})(DNABoxSpacingEnum || (DNABoxSpacingEnum = {}));
export const DNABoxSpacingKeys = [...LuxSizeKeys, ...Object.keys(DNABoxSpacingEnum)];
export var DNABoxAlignXEnum;
(function (DNABoxAlignXEnum) {
    DNABoxAlignXEnum["start"] = "start";
    DNABoxAlignXEnum["end"] = "end";
    DNABoxAlignXEnum["center"] = "end";
    DNABoxAlignXEnum["stretch"] = "stretch";
})(DNABoxAlignXEnum || (DNABoxAlignXEnum = {}));
export const DNABoxAlignXKeys = Object.keys(DNABoxAlignXEnum);
export var DNABoxAlignYEnum;
(function (DNABoxAlignYEnum) {
    DNABoxAlignYEnum["start"] = "start";
    DNABoxAlignYEnum["center"] = "center";
    DNABoxAlignYEnum["end"] = "end";
    DNABoxAlignYEnum["stretch"] = "stretch";
})(DNABoxAlignYEnum || (DNABoxAlignYEnum = {}));
export const DNABoxAlignYKeys = Object.keys(DNABoxAlignYEnum);
export var DNABoxFitEnum;
(function (DNABoxFitEnum) {
    DNABoxFitEnum["block"] = "block";
    DNABoxFitEnum["fill"] = "fill";
})(DNABoxFitEnum || (DNABoxFitEnum = {}));
export const DNABoxKeys = Object.keys(DNABoxFitEnum);
const S = {
    row: {
        alignX: {
            start: { justifyContent: 'flex-start' },
            center: { justifyContent: 'center' },
            end: { justifyContent: 'flex-end' },
            stretch: { justifyContent: 'stretch' },
        },
        alignY: {
            start: { alignItems: 'flex-start' },
            center: { alignItems: 'center' },
            end: { alignItems: 'flex-end' },
            stretch: { alignItems: 'stretch' },
        },
    },
    col: {
        alignX: {
            start: { alignItems: 'flex-start' },
            center: { alignItems: 'center' },
            end: { alignItems: 'flex-end' },
            stretch: { alignItems: 'stretch' },
        },
        alignY: {
            start: { justifyContent: 'flex-start' },
            center: { justifyContent: 'center' },
            end: { justifyContent: 'flex-end' },
            stretch: { justifyContent: 'stretch' },
        },
    },
    shrink: {
        flexShrink: 1,
    },
    wrapAlign: {
        start: { alignContent: 'flex-start' },
        center: { alignContent: 'center' },
        end: { alignContent: 'flex-end' },
        stretch: { alignContent: 'stretch' },
    },
    wrap: {
        flexWrap: 'wrap',
    },
    fill: {
        flex: 1,
    },
};
function parseComponentStyle(source) {
    const { itemMarginRight, itemMarginBottom, ...container } = source;
    return {
        container,
        itemWrapper: {
            marginRight: itemMarginRight,
            marginBottom: itemMarginBottom,
        },
    };
}
function wrapChildren(children, itemWrapper, childStyle, childFill, isReverse, keepSpacingLastItem) {
    return React.Children
        .toArray(children)
        .map((child, idx, arr) => {
        // [TODO] Figure out children types
        // @ts-ignore
        const isIffy = util.isComponent(child, Iffy);
        // @ts-ignore
        const isIs = child?.props?.is;
        if (isIffy && !isIs)
            return child;
        const isLastChild = idx === (isReverse ? 0 : (arr.length - 1));
        // [TODO]
        //  - Fix for an issue where it considers a non-rendering Iffy when using spacing
        //    Apply this when we have more time to do UI regression
        // const isLastRenderedChild = isLastChild
        //   ? true
        //   : arr
        //     .slice(idx + 1, arr.length)
        //     .every(nextChild => {
        //       // @ts-ignore
        //       const isNextChildIffy = util.isComponent(nextChild, Iffy)
        //       // @ts-ignore
        //       const isNextChildIffyRendered = nextChild?.props?.is
        //       // Skip if not an Iffy
        //       if (!isNextChildIffy) {
        //         return false
        //       }
        //       // Skip if Iffy and it's not rendered
        //       return isNextChildIffy && !isNextChildIffyRendered
        //     })
        // Recursive on the iffy uh
        // We ignore Iffy we less than 1 since they may miss being wrapped if done recurisvely due to the isLastChild rule above
        // [TODO] Consider having a style prop on Iffy which injects it to its children instead
        /* @ts-ignore */
        if (isIffy && child?.props?.children?.length > 1) {
            /* @ts-ignore */
            return wrapChildren(child?.props?.children, itemWrapper, childStyle, childFill, isReverse, keepSpacingLastItem);
        }
        const applyChildFill = (childFill !== false) && ((childFill === -1) || (childFill === idx));
        let targetStyle;
        let targetIdx;
        if (Array.isArray(childStyle)) {
            [targetIdx, targetStyle] = childStyle;
        }
        // @ts-ignore
        const childKey = child?.key ?? idx;
        // @ts-ignore
        // if (!child?.props?.key) {
        //   console.warn('DNABox spacing in-use with no child key provided! Please provide a key')
        // }
        const finalStyle = util.mergeStyles({}, [{ flex: 1 }, applyChildFill], 
        // [itemWrapper, (!isLastRenderedChild)],
        [itemWrapper, (!isLastChild || keepSpacingLastItem)], targetIdx === undefined
            ? childStyle
            : idx === targetIdx
                ? targetStyle
                : undefined);
        return (<View key={childKey} style={finalStyle}>
          {child}
        </View>);
    });
}
const DNABox = forwardRef((props, ref) => {
    const { as, eva, alignX, alignY, children, appearance = 'row', childFill, childStyle = {}, wrap, shrink, spacing, fill, keepSpacingLastItem, pointerEvents, disabled, ...rest } = props;
    const { container, itemWrapper } = parseComponentStyle(eva?.style);
    const WrappedChildren = spacing
        ? wrapChildren(children, itemWrapper, childStyle, childFill === true ? -1 : childFill, appearance.includes('Reverse'), keepSpacingLastItem)
        : children;
    const ContainerComponent = as || View;
    const disabledStyle = disabled ? { opacity: 0.4 } : undefined;
    const containerStyle = util.mergeStyles(props, [S?.[appearance]?.alignX[alignX], alignX], [S?.[appearance]?.alignY[alignY], alignY], [S.wrapAlign[wrap]], [S.fill, fill], [S.shrink, shrink], [S.wrap, wrap], container, disabledStyle);
    const isScrollView = ContainerComponent === ScrollView;
    const styleProp = {
        [isScrollView ? 'contentContainerStyle' : 'style']: containerStyle,
    };
    return (<ContainerComponent ref={ref} pointerEvents={pointerEvents || disabled ? 'none' : undefined} {...rest} {...styleProp} appearance={appearance}>
      {WrappedChildren}
    </ContainerComponent>);
});
const DNABoxStyled = styled('DNABox')(DNABox);
// @ts-ignore - [TODO-781] - Fix proper typings
DNABoxStyled.displayName = 'DNABox';
export default DNABoxStyled;
//# sourceMappingURL=DNABox.js.map